import { types } from "../action-types";

const initialState = {
    loading: false,
    details: [],
    reviewsDetails: [],
    error: false,
    notes: [],
    createNotes: false,
    success: false,
    loadingNotes:false,
    conversationID: '',
    loadingPrivate: false,
    RemoveTalentPrivate: null,
};

const getProfileDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_PROFILE_DETAILS_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.FETCH_PROFILE_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                details: action.payload,
                error: false,
            };
        case types.FETCH_PROFILE_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                details: [],
                error: true,
            };
        case types.CLEAR_ONE_USER_SKILLLISTING_SUCCESS:
            return {
                ...state,
                details: []
            }

        //profile_detail_reviews
        case types.FETCH_PROFILE_REVIEWS_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.FETCH_PROFILE_REVIEWS_SUCCESS:
            return {
                ...state,
                loading: false,
                reviewsDetails: action.payload,
                error: false,
            };
        case types.FETCH_PROFILE_REVIEWS_FAILURE:
            return {
                ...state,
                loading: false,
                reviewsDetails: [],
                error: true,
            };


        case types.GET_NOTES_SUCCESS:
            return {
                ...state,
                notes: action.payload
            }
        case types.POST_NOTES_SUCCESS:
            return {
                ...state,
                createNotes: true,
                success: true
            }
        case types.GET_NOTES_REQUESTED:
            return {
                ...state,
                createNotes: false
            }
        case types.UPDATES_NOTES_SUCCESS:
            return {
                ...state,
                createNotes: 'updated',
                loadingNotes: false,
                success: true
            }
        case types.UPDATES_NOTES_REQUESTED:
            return {
                ...state,
                loadingNotes: true,


            }
        case types.UPDATES_NOTES_FAILURE:
            return {
                ...state,
                loadingNotes: false,
                success: false
            }
        case types.UPDATES_NOTES_RESET:
            return {
                ...state,
            }
        case types.DELETE_NOTE_SUCCESS:
            return {
                ...state,
                notes: state.notes.filter((n) => n._id !== action.payload),
            }
        case types.DELETE_NOTE_FAILURE:
            return { ...state }
        case types.GET_CONVERSATION_ID_SUCCESS:
            return{
                ...state,
                conversationID: action.payload
            }
        case types.REMOVE_PRIVATE_MARKET_TALENT:
            return {
                ...state,
                loadingPrivate: true,
            }
        
        case types.REMOVE_PRIVATE_MARKET_TALENT_SUCCESS:
            return {
                ...state,
                RemoveTalentPrivate: action.payload,
                loadingPrivate: false,
            }
        
        case types.REMOVE_PRIVATE_MARKET_TALENT_FAILURE:
            return {
                ...state,
                RemoveTalentPrivate: action.payload,
                loadingPrivate: false,
            }
        default:
            return state;
    }
};

export default getProfileDetailsReducer;
